"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var i0 = require("@angular/core");
var i1 = require("./cookie.component");
var i2 = require("ng2-cookies/cookie");
var i3 = require("@angular/router");
var styles_CookieComponent = [];
var RenderType_CookieComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_CookieComponent, data: {} });
exports.RenderType_CookieComponent = RenderType_CookieComponent;
function View_CookieComponent_0(_l) { return i0.ɵvid(0, [], null, null); }
exports.View_CookieComponent_0 = View_CookieComponent_0;
function View_CookieComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "ng-component", [], null, null, null, View_CookieComponent_0, RenderType_CookieComponent)), i0.ɵdid(1, 114688, null, 0, i1.CookieComponent, [i2.CookieService, i3.Router], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_CookieComponent_Host_0 = View_CookieComponent_Host_0;
var CookieComponentNgFactory = i0.ɵccf("ng-component", i1.CookieComponent, View_CookieComponent_Host_0, {}, {}, []);
exports.CookieComponentNgFactory = CookieComponentNgFactory;
//# sourceMappingURL=cookie.component.ngfactory.js.map